import React from "react";
// import PropTypes from "prop-types";

import styled from "styled-components";

const Row = styled.tr`
  border-top: ${props => props.borderTop && "1px #66615b solid"};
`;
const LeftCol = styled.td`
  text-align: left;
`;
const RightCol = styled.td`
  text-align: right;
`;

const TableRow = ({ left, right, borderTop }) => (
  <Row borderTop={borderTop}>
    <LeftCol> {left} </LeftCol>
    <RightCol>{right}</RightCol>
  </Row>
);

// TableRow.propTypes = {};

export default TableRow;



// WEBPACK FOOTER //
// ./src/components/Table/TableRow/index.js